<template>
    <modal-frame noHeader :closeBtn="false" :width="400">
        <template #content>
            <div class="category-budget-modal not-default-fieldset">
                <div class="flex-bubble row">
                    <img :src="$variables.imgs.chatIcon" class="chat-otto-img" />

                    <svg width="15px" height="10px" class="svg-path-otto">
                        <polygon points="0,0 15,0 15,10" fill="white" class="otto-path" />
                    </svg>

                    <p class="otto-talk" v-html="speeches[stage]"></p>
                </div>

                <stacked-select
                    class="form-el"
                    label="Categoria"
                    :required="true"
                    v-if="stage === 0"
                    :errorValidation="error[1]"
                    :notTransaction="true"
                    :isGroupSelect="true"
                    :model="categories()"
                    @change="updateCategory"
                    style="margin-bottom: 16px"
                />

                <div v-if="stage === 1">
                    <div
                        class="row center"
                        style="margin: 0; margin-bottom: 8px; align-items: center; margin-top: 22px; display: flex"
                    >
                        <div class="icon-contend">
                            <img
                                :src="require('@/assets/img/categories/' + getImgUrl(category))"
                                class="icon"
                                :class="[categoryDefaultName(category), 'expenses']"
                            />
                        </div>

                        <h1 class="center category-title limited">{{ category.name }}</h1>
                    </div>

                    <div class="row" style="margin-top: 12px; flex-wrap: nowrap">
                        <unity-radio
                            :type="type"
                            :show="{ percentage: false, currency: true }"
                            @selectUnity="selectType"
                        />

                        <stacked-input
                            label="Limite"
                            style="margin-top: 0px; width: 100%"
                            :errorValidation="error[5] || error[6]"
                            :errorMsg="error[5] ? 'VALOR INVÁLIDO' : 'CADASTRE UMA RECEITA PRIMEIRO'"
                            :errorFontSize="10"
                            :required="true"
                            :money="type === 'currency' ? undefined : percentage"
                            :isMoney="true"
                            v-model="value"
                        />

                        <!-- <div style="margin: auto; margin-right: 0; margin-left: 12px">
                            <paid-icon @click="paid = !paid" :transaction-type="paidType" />
                        </div> -->
                    </div>

                    <div class="row" style="margin-bottom: 18px; margin-top: 12px; flex-wrap: nowrap">
                        <stacked-select
                            style="min-width: 80px; margin-right: 12px"
                            label="Dia"
                            :not-transaction="true"
                            :model="$moment(this._date_selected.inicio).endOf('M').date()"
                            @change="(value) => (day = value)"
                        />

                        <stacked-input
                            style="margin-right: 12px; min-width: 80px"
                            label="Parcelas"
                            type="number"
                            min="0"
                            max="999"
                            step="1"
                            :value="lastInstallment"
                            :reviewValue="true"
                            @input="updateLastInstallment"
                        />

                        <stacked-select
                            style="width: 100%"
                            label="Repetir"
                            :previous-selected="updatedRecurrentType"
                            :model="recurrencyPeriods"
                            :reviewValue="true"
                            @change="updateRecurrentType"
                        />
                    </div>
                </div>
            </div>
        </template>

        <template #btn-container>
            <div class="button-wrapper">
                <basic-button
                    :label="`${stage === 0 ? 'PRÓXIMO' : 'DEFINIR LIMITE'}`"
                    style="margin-bottom: 8px"
                    @click="selectCategory"
                    width="100%"
                />
                <basic-button label="CANCELAR" :reverse="true" @click="() => $emit('closeModalEvent')" width="100%" />
            </div>
        </template>
    </modal-frame>
</template>

<script>
import { mapState } from 'pinia'
import { mainStore } from '../../store'

import BasicButton from '../buttons/BasicButton.vue'
import StackedSelect from '../inputs/StackedSelect.vue'
import ConfirmationCreateModal from './confirmation-modals/ConfirmationCreateModal.vue'
import UnityRadio from '../inputs/UnityRadio.vue'
import StackedInput from '../inputs/StackedInput.vue'
import ModalFrame from '../../containers/ModalFrame.vue'
import PaidIcon from '../icons/PaidIcon.vue'

import util from '../../common/util'

export default {
    components: {
        ConfirmationCreateModal,
        BasicButton,
        StackedSelect,
        UnityRadio,
        StackedInput,
        ModalFrame,
        PaidIcon,
    },

    name: 'CategoryBudgetModal',

    props: {
        addedCategories: Object,
        revenues: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            category: {},
            error: [],
            speeches: [
                'Para começar, selecione uma categoria de despesas na lista abaixo.',
                'Agora, defina um limite de gastos para ela. Pode ser um valor fixo ou uma porcentagem do orçamento.',
            ],
            stage: 0,
            value: 0,
            lastInstallment: '',
            recurrentType: '',
            paid: false,
            day: this.$moment().date(),
            updatedRecurrentType: '',
            type: 'currency',
            percentage: {
                decimal: ',',
                thousands: '.',
                suffix: '%',
                precision: 0,
                masked: false,
            },

            recurrencyPeriods: [
                {
                    _id: 'monthly',
                    name: 'mensalmente',
                },
                {
                    _id: 'semiannual',
                    name: 'semestralmente',
                },
                {
                    _id: 'annual',
                    name: 'anualmente',
                },
            ],
        }
    },

    methods: {
        updateCategory(value) {
            this.category = value
        },

        updateRecurrentType(value) {
            this.recurrentType = this.updatedRecurrentType = value
            this.lastInstallment = this.updatedLastInstallment = ''
        },

        updateLastInstallment(value) {
            if (!value) this.lastInstallment = this.updatedLastInstallment = ''
            else if (value > 999) this.lastInstallment = this.updatedLastInstallment = 999
            else this.lastInstallment = this.updatedLastInstallment = value

            this.recurrentType = this.updatedRecurrentType = ''
        },

        selectCategory() {
            let error = Array(7).fill(false)

            if (this.stage === 0) {
                if (this.category._id) {
                    this.stage = 1
                } else {
                    error[1] = true
                    this.error = error
                }
            } else {
                let budgetValue = 0
                let budgetValueInCurrency = 0

                if (this.type === 'currency') {
                    budgetValueInCurrency = Number(util.sanitizeMoney(this.value))
                    budgetValue = (Number(util.sanitizeMoney(this.value)) / (this.revenues || 1)) * 100
                } else {
                    const percentage = util.sanitizePercentage(this.value)

                    budgetValueInCurrency = (percentage * this.revenues) / 100
                    budgetValue = percentage
                }

                if (!util.sanitizeMoney(this.value) || this.value === '0%') {
                    error[5] = true
                    this.error = error
                } else {
                    let categoryToAdd = {
                        category: this.category,
                        budgetValue: !budgetValue ? 0 : budgetValue,
                        value: budgetValueInCurrency,
                        mode: 'add',
                        paid: this.paid,
                        day: this.day,
                    }

                    if (this.lastInstallment) categoryToAdd.lastInstallment = this.lastInstallment
                    if (this.recurrentType) categoryToAdd.recurrentType = this.recurrentType

                    this.$emit('closeModalEvent', categoryToAdd)
                }
            }
        },

        sanitize(string) {
            return util.sanitize(string)
        },

        parsePercentage: (percentage) => {
            return util.sanitizePercentage(percentage) / 100
        },

        selectType(payload) {
            console.log(payload)
            if (payload === this.type) return

            this.type = payload

            switch (payload) {
                case 'currency':
                    this.value = util.formatNumber(this.revenues * this.parsePercentage(this.value))
                    break
                default:
                    this.value = Math.round(
                        (Number(util.sanitizeMoney(this.value)) / (this.revenues || this.value || 1)) * 100,
                    )
            }
        },

        categoryDefaultName(category) {
            return util.sanitizeCategoryName(category)
        },

        getImgUrl(category) {
            return util.getImgUrl(category)
        },

        categories() {
            let revenues = this.filteredCategories('revenues', this.selectedUser)

            const payload = [
                {
                    name: 'Receitas',
                    data: revenues,
                },
                ...this.newGroupedCategories(false, true, this.selectedUser),
            ]

            if (this.addedCategories.allIds.length) {
                let addedCategoriesIds = this.addedCategories.allIds

                payload.forEach((item) => {
                    item.data = item.data.filter((content) => {
                        return !addedCategoriesIds.includes(content._id)
                    })
                })
            }

            return payload
        },
    },

    computed: {
        ...mapState(mainStore, ['filteredCategories', 'newGroupedCategories', 'selectedUser', '_date_selected']),

        paidType() {
            return this.paid ? this.category.group : undefined
        },
    },
}
</script>

<style lang="scss" scoped>
.category-budget-modal {
    margin-top: -42px;
    border-radius: 8px;
    background: white;

    &:disabled {
        cursor: wait;
    }
}

.loader {
    font-size: 14px;
    margin: 0;
}

.chat-otto-img,
.chat-user-img {
    position: relative;
    top: 200;
    width: 30px;
    height: 30px;
    background: white;
    border-radius: 50%;
    padding: 4px;
    box-shadow: 1px 1px 2px #00000030;
    border: 1px solid $btn-blue;
}

.otto-talk {
    left: -3px;
    background-color: #ffffff;
    text-align: left;
    margin-bottom: 8px;
    color: #5b6772;
}

.user-talk,
.otto-talk {
    position: relative;
    max-width: 287px;
    line-height: 18px;
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.flex-bubble {
    display: flex;
    margin-bottom: 8px;
    &.column {
        flex-direction: column;
    }
}

.row {
    flex-direction: row;
    margin: 0;
    display: flex;
}

.button-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    color: #d0021b;
}

.icon-contend {
    height: 24px !important;
    .icon {
        height: 24px;
        width: 24px;
        border-radius: 50%;
    }
}

.category-title {
    font-weight: 500;
    font-size: 16px;
    color: #1e3351;
    margin-left: 8px;
}
</style>
